import notificationLogo from '../assets/driver-360-notification-logo.png'
import { FOREGROUND_NOTIFICATION_APP_NAME } from '../utils/foregroundNotification'
import styles from './ForegroundPushNotification.module.scss'

export interface ForegroundPushNotificationProps {
  title: string
  summary?: string
  detail?: string
}

const ForegroundPushNotification = ({
  title,
  summary,
  detail,
}: ForegroundPushNotificationProps) => (
  <div className={styles.content}>
    <img
      className={styles.logo}
      src={notificationLogo}
      alt=""
      width={40}
      height={40}
    />
    <div className={styles.copy}>
      <div className={styles.header}>
        <span className={styles.applicationName}>
          {FOREGROUND_NOTIFICATION_APP_NAME}
        </span>
        <span className={styles.time}>Now</span>
      </div>
      <p className={styles.title}>{title}</p>
      {summary && <p className={styles.line}>{summary}</p>}
      {detail && <p className={styles.line}>{detail}</p>}
    </div>
  </div>
)

export default ForegroundPushNotification
